var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullText"},[_c('FullTextMark'),_c('Explain'),_c('ReportFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }